/**
 * 本番ビルドなら真
 */
export function onProduction(): boolean {
  return process.env.NODE_ENV === "production";
}
